import { formatNumber } from '../../core/formatter/formatNumber';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import * as React from 'react';
// import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WpdfText } from '../datenauswertung/pdf/WpdfText.';
import { WpdfView } from '../datenauswertung/pdf/WpdfView';
import { SectionStyle } from '../../helpers/SectionStyle';

interface ZusatztoolsSteuerStromProps extends React.ClassAttributes<any> {
    data: any;
    hauptzollamt: string;
    isPdf?: boolean;
    jahr: number;
}

export class ZusatztoolsSteuerStrom extends React.Component<ZusatztoolsSteuerStromProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    getStyle(): any {
        const isPdf: boolean = this.props.isPdf || false;

        const Section: any = new SectionStyle();
        const headerBgColor = Section.getPropertyValue('--color-main-section-datenauswertung');
        const rowBgColor = Section.getPropertyValue('--color-breadcrumb-background');

        return ({
            main: {
                display: 'flex',
                flexDirection: 'column'
            },
            ueberschrift: {
                ...(isPdf && { fontFamily: 'Helvetica-Bold' }),
                fontSize: '11pt',
                fontWeight: 'bold',
                maxWidth: 650,
                margin: '20px 20px 0 0',
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            hinweis: {
                fontSize: '9pt',
                maxWidth: 650,
                margin: '15px 20px 0 0',
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            tabelle: {
                fontSize: '9pt',
                maxWidth: 650,
                margin: '15px 20px 0 0',
                border: '1pt solid white',
                display: 'flex',
                flex: 0,
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            row: {
                backgroundColor: rowBgColor,
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            row_header: {
                ...(isPdf && { fontFamily: 'Helvetica-Bold' }),
                fontWeight: 'bold',
                color: 'white',
                backgroundColor: headerBgColor
            },
            row_first: {
                marginTop: 6
            },
            colgroup: {
                ...(!isPdf && { minHeight: 27 }),
                display: 'flex',
                flex: 1,
                flexDirection: 'column'
            },
            colgroup_header: {
            },
            col1: {
                flexBasis: '78%'
            },
            col1_header: {
                flexBasis: '78%',
                flexDirection: 'row'
            },
            col2: {
                flexBasis: '10%'
            },
            col2_header: {
                flexBasis: '10%'
            },
            col3: {
                flexBasis: '2%'
            },
            col3_header: {
                flexBasis: '2%'
            },
            cell: {
                textAlign: 'left',
                padding: isPdf ? 2 : 4,
                ...(isPdf && { paddingTop: 4, paddingBottom: 4 }),
                borderTop: '1pt solid white',
                borderLeft: '1pt solid white',
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-start',
                ...(!isPdf && { alignItems: 'center' }),
                boxSizing: 'border-box'
            },
            cell_header: {
            },
            cell_bold: {
                ...(isPdf && { fontFamily: 'Helvetica-Bold' }),
                fontWeight: 'bold'
            },
            cell_italic: {
                ...(isPdf && { fontFamily: 'Helvetica-Oblique' }),
                fontStyle: 'italic'
            },
            cell_nobgcolor: {
                backgroundColor: 'white'
            },
            cell_right: {
                textAlign: 'right',
                justifyContent: 'flex-end'
            },
            cell_stromsteuer: {
                backgroundColor: 'white',
                paddingBottom: 0,
                borderTop: isPdf ? '4pt solid white' : '6pt solid white'
            },
            cell1: {
            },
            cell2: {
                textAlign: 'right',
                justifyContent: 'flex-end'
            },
            cell2_header: {
                textAlign: 'right',
                borderLeft: 'none',
                justifyContent: 'flex-end'
            },
            cell3: {
                borderLeft: 'none'
            },
            cell3_header: {
                textAlign: 'right',
                borderLeft: 'none',
                justifyContent: 'flex-end'
            },
            cell4: {
                borderLeft: 'none'
            }
        });
    }

    render(): JSX.Element {
        if (!this.props.jahr) {
            return null;
        }
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return (
            <WpdfView style={styles.main} pdf={isPdf}>
                {this.renderUeberschrift()}
                {this.renderTabelle()}
            </WpdfView>
        );
    }

    renderTabelle(): JSX.Element {
        const data: any = (this.props.data[IDs.STEUER_STROM] || {})[this.props.jahr] || {};
        // console.log('Steuer Strom', data);
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        if (!(data.hasParameter || false)) {
            return (
                <WpdfView style={styles.hinweis} pdf={isPdf}>
                    <WpdfText pdf={isPdf}>
                        {i18n('Es konnten keine Parameter für das Jahr {{1}} gefunden werden, bitte kontaktieren Sie Ihren Ansprechpartner:in', 'sys').replace('{{1}}', this.props.jahr)}
                    </WpdfText>
                </WpdfView>
            );
        }

        // const helpIconEntlastungsbetrag: JSX.Element = (
        //     <WHelpIcon
        //         data={this.props.data}
        //         styleDivProps={{ display: 'inline-block' }}
        //         styleProps={{
        //             width: 18, height: 18, borderRadius: 10, backgroundColor: 'var(--color-main-section-datenauswertung)',
        //             verticalAlign: 'top', margin: 0, marginRight: 4
        //         }}
        //         label='Hinweise Strom'
        //         helpKey='steuer_hinweise_strom'
        //         type='info'
        //         editBar
        //     />
        // );

        const weitergeleitete_strommenge_kwh = data.weitergeleitete_strommenge_kwh || 0;
        const stromverbrauch_efahrzeuge = data.stromverbrauch_efahrzeuge || 0;
        const stromverbrauch_rechnung = data.stromverbrauch_rechnung || 0;
        const stromverbrauch_beguenstigte = data.stromverbrauch_beguenstigte || 0;

        return (
            <WpdfView style={styles.tabelle} pdf={isPdf}>
                <WpdfView style={{ ...styles.row, ...styles.row_header }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col1_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell1_header }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{i18n('Berechnung Stromsteuer', 'sys')}</WpdfText>
                        </WpdfView>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell2_header }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{i18n('Jahr', 'sys')}:</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col2_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell3_header }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{this.props.jahr}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col3_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell4 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}></WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>

                {(weitergeleitete_strommenge_kwh > 0 || stromverbrauch_efahrzeuge > 0) &&
                    <WpdfView style={{ ...styles.row, ...styles.row_first }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell1 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>{i18n('Gesamtstromverbrauch gemäß Rechnung(en) des Energieversorgers', 'sys')}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>{formatNumber(stromverbrauch_rechnung, 2)}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>kWh</WpdfText>
                            </WpdfView>
                        </WpdfView>
                    </WpdfView>
                }

                {weitergeleitete_strommenge_kwh > 0 &&
                    <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell1 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>{i18n('Weitergeleitete Strommengen', 'sys')}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>-{formatNumber(weitergeleitete_strommenge_kwh, 2)}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>kWh</WpdfText>
                            </WpdfView>
                        </WpdfView>
                    </WpdfView>
                }

                {stromverbrauch_efahrzeuge > 0 &&
                    <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell1 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>{i18n('Strom für im Straßenverkehr genutzte E-Fahrzeuge (nicht begünstigt)', 'sys')}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>-{formatNumber(stromverbrauch_efahrzeuge, 2)}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>kWh</WpdfText>
                            </WpdfView>
                        </WpdfView>
                    </WpdfView>
                }

                <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1, ...styles.cell_bold }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{i18n('Begünstigte Strommenge', 'sys')}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2, ...styles.cell_bold }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{formatNumber(stromverbrauch_beguenstigte, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3, ...styles.cell_bold }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>kWh</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>
                                {i18n('Info', 'sys')}: {i18n('Über Stromrechnungen bereits abgeführte Stromsteuer', 'sys')}
                                ({formatNumber(data.steuersatz_voll || 0, 2)} €/MWh):
                            </WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{formatNumber(data.steuer_verbrauch_voll || 0, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>€</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1, display: 'flex', flexDirection: 'row' }} pdf={isPdf}>
                            <WpdfText pdf={isPdf} style={{ display: 'inline' }}>
                                {i18n('Entlastungsbetrag', 'sys')} ({formatNumber(data.steuersatz_erm || 0, 2)} €/MWh):
                            </WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{formatNumber(data.entlastungsbetrag || 0, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>€</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView
                            style={{ ...styles.cell, ...styles.cell1, ...styles.cell_right, ...styles.cell_stromsteuer }}
                            pdf={isPdf}
                        >
                            <WpdfText pdf={isPdf}>{i18n('abzüglich Sockelbetrag nach § 9b Abs.2 StromStG', 'sys')}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2, ...styles.cell_stromsteuer }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>-{formatNumber(data.selbstbehalt_strom || 0, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3, ...styles.cell_stromsteuer }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>€</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView
                            style={{ ...styles.cell, ...styles.cell1, ...styles.cell_right, ...styles.cell_bold, ...styles.cell_nobgcolor }}
                            pdf={isPdf}
                        >
                            <WpdfText pdf={isPdf}>{i18n('Vom Hauptzollamt zu erstattender Betrag', 'sys')}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2, ...styles.cell_bold }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{formatNumber(data.erstattung || 0, 2)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>€</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
            </WpdfView>
        );
    }

    renderUeberschrift(): JSX.Element {
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return <>
            {!!this.props.hauptzollamt &&
                <WpdfView style={styles.ueberschrift} pdf={isPdf}>
                    <WpdfText pdf={isPdf}>
                        {i18n('Zuständiges Hauptzollamt', 'sys')}: {this.props.hauptzollamt}
                    </WpdfText>
                </WpdfView>
            }
            <WpdfView style={styles.ueberschrift} pdf={isPdf}>
                <WpdfText pdf={isPdf}>I) {i18n('Strom', 'sys')} (§9b StromStG)</WpdfText>
            </WpdfView>
        </>;
    }
}
